import styles from './Skeleton.module.css'

interface SkeletonProps {
  width?: string
  height?: string
  variant?: 'text' | 'rectangular' | 'circular'
  className?: string
}

export function Skeleton({ width, height, variant = 'text', className = '' }: SkeletonProps) {
  return (
    <div
      className={`${styles.skeleton} ${styles[variant]} ${className}`}
      style={{ width, height }}
    />
  )
}

interface SkeletonTextProps {
  lines?: number
  className?: string
}

export function SkeletonText({ lines = 3, className = '' }: SkeletonTextProps) {
  return (
    <div className={`${styles.textContainer} ${className}`}>
      {Array.from({ length: lines }).map((_, index) => (
        <Skeleton key={index} variant="text" width={index === lines - 1 ? '70%' : '100%'} />
      ))}
    </div>
  )
}

interface SkeletonCardProps {
  className?: string
}

export function SkeletonCard({ className = '' }: SkeletonCardProps) {
  return (
    <div className={`${styles.card} ${className}`}>
      <Skeleton variant="rectangular" height="120px" />
      <div className={styles.cardContent}>
        <Skeleton variant="text" width="60%" height="1.25rem" />
        <Skeleton variant="text" width="80%" />
        <Skeleton variant="text" width="40%" />
      </div>
    </div>
  )
}
